"use strict";

exports.__esModule = true;
exports.AppSidebar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@blueprintjs/core");
var _Theme = require("../../Theme");
var _System = require("../../../System");
var _Auth = require("../../Auth");
var _AppIcon = require("../AppIcon");
var _Core = require("../../Core");
var _CreateTicketDialog = require("./CreateTicketDialog");
var _isInIFrame = require("../../../Utils/isInIFrame");
var _EnvContext = require("../../Env/EnvContext");
var _getPartnerUrls = _interopRequireDefault(require("../../LandingScreen/ElevateSettingsMenu/getPartnerUrls"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LogoLink = (0, _styledComponents["default"])(_reactRouterDom.NavLink).withConfig({
  displayName: "AppSidebarmodern__LogoLink",
  componentId: "sc-6molps-0"
})(["width:", ";height:", ";min-height:", ";background:", " center center no-repeat;text-decoration:none;border-bottom:solid 1px ", ";"], (0, _Theme.val)("SidebarWidth"), (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("SquareLogo"), (0, _Theme.val)("SidebarIconBorderBottom"));

// The plant name and the "New" button form the rail's bottom group, pinned
// above the collapse button so nothing can land on top of either. Collapsed:
// vertical text reading upwards. Expanded: a normal line.
var PlantLabel = _styledComponents["default"].div.withConfig({
  displayName: "AppSidebarmodern__PlantLabel",
  componentId: "sc-6molps-1"
})(["flex:none;align-self:center;margin:12px 0 4px;margin-top:auto;max-height:calc(", " - 20px);overflow:hidden;color:", ";font-family:", ";font-weight:700;font-size:13px;line-height:1;letter-spacing:-0.01em;white-space:nowrap;text-overflow:ellipsis;writing-mode:vertical-rl;transform:rotate(180deg);opacity:0.95;pointer-events:none;"], (0, _Theme.val)("SidebarExpandedWidth"), (0, _Theme.val)("SidebarLinkColor"), (0, _Theme.val)("FontFamilyHeading"));
var PoweredByLogoContainer = _styledComponents["default"].div.withConfig({
  displayName: "AppSidebarmodern__PoweredByLogoContainer",
  componentId: "sc-6molps-2"
})(["position:absolute;bottom:calc(", " + ", ");display:none;width:100%;height:70px;background:", ";transition:all ", ";"], (0, _Theme.val)("SidebarIconHeight"), (0, _Theme.val)("BrowserStatusBarHeight"), function (props) {
  return props.logoBG;
}, (0, _Theme.val)("SidebarTransitionDuration"));

// Collapsed: a rail button with the icon above a short label (the next-gen
// design). Expanded: icon and full title in a row, as before.
var SidebarLink = (0, _styledComponents["default"])(_reactRouterDom.NavLink).withConfig({
  displayName: "AppSidebarmodern__SidebarLink",
  componentId: "sc-6molps-3"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px;width:calc(", " - 12px);min-height:50px;margin:2px 6px;padding:6px 2px 5px;border-radius:10px;cursor:pointer;text-decoration:none;color:", ";z-index:1;transition:background-color 120ms ease;&:hover{background-color:", ";text-decoration:none;}&::after{content:attr(data-short);max-width:60px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:", ";font-size:10px;line-height:1;letter-spacing:0.01em;font-weight:", ";}&.active{color:", ";background:", ";&::after{color:", ";}}&.createNew{margin-top:4px;}"], (0, _Theme.val)("SidebarWidth"), (0, _Theme.val)("SidebarLinkColor"), (0, _Theme.val)("SidebarIconHoverBackground"), (0, _Theme.val)("SidebarLinkColor"), (0, _Theme.val)("SidebarLinkFontWeight"), (0, _Theme.val)("SidebarActiveColor"), (0, _Theme.val)("SidebarIconActiveBackground"), (0, _Theme.val)("SidebarActiveColor"));
var SidebarContainer = _styledComponents["default"].aside.withConfig({
  displayName: "AppSidebarmodern__SidebarContainer",
  componentId: "sc-6molps-4"
})(["display:flex;height:100vh;box-sizing:border-box;padding-bottom:calc( ", " + ", " );flex-direction:column;flex-shrink:0;position:relative;width:", ";background:", ";border-right:solid 1px ", ";overflow:hidden;transition:ease-out width ", ";&.expanded.has-powered-by{padding-bottom:calc( ", " + ", " + 78px );}&.expanded{width:", ";background:", ";", "{width:", ";background:", " center center no-repeat;background-size:", ";}", "{align-self:flex-start;margin-left:12px;writing-mode:horizontal-tb;transform:none;width:calc(", " - 20px);max-height:none;line-height:1.2;}", "{display:block;}", "{flex-direction:row;justify-content:flex-start;gap:12px;width:calc(", " - 12px);min-height:44px;padding:0 12px;&::after{content:attr(data-title);max-width:128px;white-space:normal;font-size:13px;line-height:1.2;}}}"], (0, _Theme.val)("SidebarIconHeight"), (0, _Theme.val)("BrowserStatusBarHeight"), (0, _Theme.val)("SidebarWidth"), (0, _Theme.val)("SidebarBackground"), (0, _Theme.val)("SidebarBorderRight"), (0, _Theme.val)("SidebarTransitionDuration"), (0, _Theme.val)("SidebarIconHeight"), (0, _Theme.val)("BrowserStatusBarHeight"), (0, _Theme.val)("SidebarExpandedWidth"), (0, _Theme.val)("SidebarHoverBackground"), LogoLink, (0, _Theme.val)("SidebarExpandedWidth"), (0, _Theme.val)("LandingLogo"), (0, _Theme.val)("backgroundSize"), PlantLabel, (0, _Theme.val)("SidebarExpandedWidth"), PoweredByLogoContainer, SidebarLink, (0, _Theme.val)("SidebarExpandedWidth"));
var SidebarAnchor = SidebarLink.withComponent("a");
var SidebarIcon = (0, _styledComponents["default"])(_AppIcon.AppIcon).withConfig({
  displayName: "AppSidebarmodern__SidebarIcon",
  componentId: "sc-6molps-5"
})(["width:26px;height:26px;margin:0;outline:none;object-fit:contain;"]);
var CreateNewTicketIcon = (0, _styledComponents["default"])(_AppIcon.AppIcon).withConfig({
  displayName: "AppSidebarmodern__CreateNewTicketIcon",
  componentId: "sc-6molps-6"
})(["width:30px;height:30px;outline:none;object-fit:contain;"]);
var ToggleButton = (0, _styledComponents["default"])(_core.Button).withConfig({
  displayName: "AppSidebarmodern__ToggleButton",
  componentId: "sc-6molps-7"
})(["position:absolute;bottom:", ";width:100%;text-align:left;display:flex;justify-content:flex-start;padding:0;outline:none;.", "{width:", ";height:", ";margin:0;display:flex;align-items:center;justify-content:center;}.", ",.", "{color:", ";}"], (0, _Theme.val)("BrowserStatusBarHeight"), _core.Classes.ICON, (0, _Theme.val)("SidebarWidth"), (0, _Theme.val)("SidebarIconHeight"), _core.Classes.ICON, _core.Classes.BUTTON_TEXT, (0, _Theme.val)("SidebarLinkColor"));
var AppSidebar = exports.AppSidebar = function AppSidebar(_ref) {
  var plantName = _ref.plantName,
    isSidebarExpanded = _ref.isSidebarExpanded,
    setIsSidebarExpanded = _ref.setIsSidebarExpanded;
  var _useState = (0, _react.useState)(false),
    createTicketDialogVisible = _useState[0],
    setCreateTicketDialogVisible = _useState[1];
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var PoweredByLogo = theme.PoweredByLogo;
  var env = (0, _react.useContext)(_EnvContext.EnvContext);
  var poweredByOrCopyright = PoweredByLogo ? /*#__PURE__*/_react["default"].createElement(PoweredByLogoContainer, {
    logoBG: PoweredByLogo
  }) : null;
  return (0, _isInIFrame.isInIFrame)() ? null : /*#__PURE__*/_react["default"].createElement(SidebarContainer, {
    "data-testid": "AppSidebar",
    className: (isSidebarExpanded ? "expanded" : "") + " " + (poweredByOrCopyright ? "has-powered-by" : "")
  }, /*#__PURE__*/_react["default"].createElement(LogoLink, {
    "data-testid": "AppSidebar-Logo",
    to: "/"
  }), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_DASHBOARDS"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("DashboardList"),
    "data-testid": "AppSidebar-Dashboards",
    "data-short": translate("AppSidebar.short.dashboards", "Dash"),
    "data-title": translate("AppList.dashboards.title", "Dashboards")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "dashboard",
    alt: "dashboards"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_REPORTS"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("ReportList"),
    "data-testid": "AppSidebar-Reports",
    "data-short": translate("AppSidebar.short.reports", "Reports"),
    "data-title": translate("AppList.reports.title", "Reports")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "reports",
    alt: "reports"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_OPERATOR_PANELS"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("OperatorPanelList"),
    "data-testid": "AppSidebar-OperatorPanel",
    "data-short": translate("AppSidebar.short.operatorPanel", "Operator"),
    "data-title": translate("AppList.operatorPanel.title", "Operator Panel")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "operator",
    alt: "operator"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_ALERT"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("AlertList"),
    "data-testid": "AppSidebar-Alerts",
    "data-short": translate("AppSidebar.short.alerts", "Alerts"),
    "data-title": translate("AppList.alerts.title", "Alerts")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "alerts",
    alt: "alerts"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_MAINTENANCE_MANAGER"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("MaintenanceManagerLanding"),
    "data-testid": "AppSidebar-MaintenanceManager",
    "data-short": translate("AppSidebar.short.maintenanceManager", "Maint."),
    "data-title": translate("AppList.MaintenanceManager.title", "Maintenance Manager")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "maintenance-manager",
    alt: "Maintenance Manager"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_TICKETING"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("TicketList"),
    "data-testid": "AppSidebar-Tickets",
    "data-short": translate("AppSidebar.short.tickets", "Tickets"),
    "data-title": translate("AppList.tickets.title", "Tickets")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "tickets",
    alt: "tickets"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "EDIT_KNOWLEDGE_BASE"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("WorkInstructionList"),
    "data-testid": "AppSidebar-WorkInstructions",
    "data-short": translate("AppSidebar.short.workInstructions", "Knowl."),
    "data-title": translate("AppList.workInstructions.title", "Knowledge Base")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "knowledge-base",
    alt: "knowledgeBase"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "EDIT_DECISION_TREE"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("DecisionTreeList"),
    "data-testid": "AppSidebar-DecisionTree",
    "data-short": translate("AppSidebar.short.decisionTree", "Rules"),
    "data-title": translate("AppList.decisionTree.title", "Decision Tree")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "decision-tree",
    alt: "decisionTree"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_DATA_ON_DEMAND"
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("DataOnDemandScreen"),
    "data-testid": "AppSidebar-DataOnDemand",
    "data-short": translate("AppSidebar.short.dataOnDemand", "Data"),
    "data-title": translate("AppList.dataOnDemand.title", "Data On Demand")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "data-on-demand",
    alt: "dataOnDemand"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: ["DOWNLOAD_DEVICE_DATA_BASIC", "DOWNLOAD_DEVICE_DATA_ADVANCED"]
  }, /*#__PURE__*/_react["default"].createElement(SidebarLink, {
    to: (0, _System.getScreenLocation)("ExportDeviceData"),
    "data-testid": "AppSidebar-ExportDeviceData",
    "data-short": translate("AppSidebar.short.exportDeviceData", "Export"),
    "data-title": translate("AppList.exportDeviceData.title", "Download Device Data")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "export-device-data",
    alt: "exportDeviceData"
  }))), /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "VIEW_DOCUMENTATION"
  }, /*#__PURE__*/_react["default"].createElement(SidebarAnchor, {
    href: (0, _getPartnerUrls["default"])(env, "documentationUrl"),
    target: "_blank",
    rel: "noopener noreferrer",
    "data-testid": "AppSidebar-Documentation",
    "data-short": translate("AppSidebar.short.docs", "Docs"),
    "data-title": translate("AppList.docs.title", "Docs")
  }, /*#__PURE__*/_react["default"].createElement(SidebarIcon, {
    name: "docs",
    alt: "docs"
  }))), /*#__PURE__*/_react["default"].createElement(PlantLabel, null, plantName), /*#__PURE__*/_react["default"].createElement(SidebarAnchor, {
    className: "createNew",
    "data-testid": "AppSidebar-CreateNew",
    "data-short": translate("AppSidebar.short.createNew", "New"),
    "data-title": translate("AppSidebar.createNewTicket.title", "Create New"),
    onClick: function onClick() {
      return setCreateTicketDialogVisible(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(CreateNewTicketIcon, {
    name: "sidebar-newticket-plus",
    alt: "newTicketIcon"
  })), createTicketDialogVisible && /*#__PURE__*/_react["default"].createElement(_CreateTicketDialog.CreateTicketDialog, {
    isSidebarExpanded: isSidebarExpanded,
    isOpen: createTicketDialogVisible,
    onClose: function onClose() {
      return setCreateTicketDialogVisible(false);
    }
  }), poweredByOrCopyright, isSidebarExpanded ? /*#__PURE__*/_react["default"].createElement(ToggleButton, {
    icon: "menu-closed",
    className: _core.Classes.MINIMAL,
    text: "" + (isSidebarExpanded ? translate("DeviceInfo.collapsed.icon.title", "Collapse") : ""),
    onClick: function onClick() {
      setIsSidebarExpanded(!isSidebarExpanded);
    }
  }) : /*#__PURE__*/_react["default"].createElement(ToggleButton, {
    icon: "menu-open",
    className: _core.Classes.MINIMAL,
    text: " ",
    onClick: function onClick() {
      setIsSidebarExpanded(!isSidebarExpanded);
    }
  }));
};